"use client";

import { BrochureProvider } from "./Brochure";
import { NotifyProvider } from "./Notify";

export default function Providers({ children }) {
  return (
    <BrochureProvider>
      <NotifyProvider>{children}</NotifyProvider>
    </BrochureProvider>
  );
}
